import React, { memo, useCallback } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import styles from '../styles/navbar.module.css';
import companyLogo from '../../assets/images/logo.webp';
import { FaBars, FaTimes } from 'react-icons/fa';
import MenuItem from './MenuItem';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = useCallback(() => {
    setMenuOpen(prev => !prev);
  }, []);

  // const toggleToEnglish = useCallback(() => {
  //   localStorage.setItem('language', 'en');
  //   const newPath = location.pathname.replace('/jp', '/en');
  //   navigate(newPath);
  // }, [navigate, location]);

const toggleToEnglish = useCallback(() => {
  localStorage.setItem('language', 'en');
  navigate('/en');
}, [navigate]);

  const successStoriesDropdownItems = React.useMemo(() => [
    { path: "/jp/success-story-finTech", label: "デジタルファイナンスのためのフィンテックソリューション " },
    { path: "/jp/success-story-retailBanking", label: "リテールバンキング " },
    { path: "/jp/success-story-digitalPayment", label: "デジタル決済サービスプロバイダー " },
    { path: "/jp/success-story-loanEnquiry", label: "スマートカーローンプラットフォーム " },
    { path: "/jp/success-story-webApplication", label: "Webアプリケーションの基盤移行 " },
  ], []);

  const aboutUsDropdownItems = React.useMemo(() => [
  { path: "/jp/about#company-vision", label: "私たちについて" },
  //{ path: "/jp/about#board-members", label: "理事会" },
  { path: "/jp/about#life-at-dgft", label: "治革" },
  { path: "/jp/about#why-choose-us", label: "当社を選ぶ理由" },
  { path: "/jp/about#benefits", label: "利点 そして 特徴" },
//  { path: "/jp/about#corporate-profile", label: "会社概要" },
], []);


  const menuItems = React.useMemo(() => [
    { path: '/jp/CompanyProfile', label: '会社概要'},
    { path: '/jp/about', label: '会社情報', hasDropdown: true, dropdownItems: aboutUsDropdownItems },
    { path: '/jp/managed-services', label: 'サービス '},
    //{ path: '/jp/serviceplans', label: 'サービスプラン ' },
    { path: '/jp/success-stories', label: 'ケーススタディ', hasDropdown: true, dropdownItems: successStoriesDropdownItems },
    { path: '/jp/Contact', label: 'お問い合わせ ' },
  ], [successStoriesDropdownItems, aboutUsDropdownItems]);

    return (
    <nav className={styles.navbar} role="navigation">
      <div className={styles.navbarContainer}>
        <div className={styles.navbarLogo}>
          <NavLink to="/jp">
            <img
              src={companyLogo}
              alt="DG FutureTech Logo"
              className={styles.logo}
              width="120"
              height="40"
              loading="eager"
              fetchPriority="high"
            />
          </NavLink>
        </div>

        <div className={styles.emptySpace}></div>

        <div className={styles.navLinksContainer}>
          <div className={`${styles.navbarMenu} ${menuOpen ? styles.navbarMenuOpen : ''}`}>
            {menuItems.map((item, index) => (
              <MenuItem
                key={item.path}
                {...item}
                isLast={index === menuItems.length - 1}
                toggleMenu={toggleMenu}
                isMenuOpen={menuOpen}
              />
            ))}

            <a  
          href="https://prtimes.jp/main/html/rd/p/000000001.000189048.html"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.noticeButton}
          >
            お知らせ
          </a>

            {/* Language change button */}
            <button
              onClick={toggleToEnglish}
              style={{
                //border: "2px solid #007BFF",
                border: "2px solid #2D5CFF",
                borderRadius: "5px",
                padding: "8px 16px",
                fontSize: "1rem",
                cursor: "pointer",
                fontWeight: "500",
                marginLeft: "14px"
              }}
            >
              English
            </button>
          </div>

          <button
            className={styles.hamburger}
            onClick={toggleMenu}
            aria-expanded={menuOpen}
            aria-label="Toggle navigation menu"
            type="button"
          >
            {!menuOpen ? <FaBars aria-hidden="true" /> : <FaTimes aria-hidden="true" />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default memo(Navbar);